import { render, staticRenderFns } from "./ReturnNavBar.vue?vue&type=template&id=046d1c0e&scoped=true&"
import script from "./ReturnNavBar.vue?vue&type=script&lang=js&"
export * from "./ReturnNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d1c0e",
  null
  
)

export default component.exports